import { LanguageCode } from "./LanguageCode";

export const TutorialMixin = {
  methods: {
    getContext() {
      let locale = LanguageCode.getLanguage(this.$i18n.locale);
      switch (locale) {
        case "fr":
          return require.context("@/assets/tutorials/fr", false, /\.png$/);
        case "it":
          return require.context("@/assets/tutorials/it", false, /\.png$/);
        case "rm":
          return require.context("@/assets/tutorials/rm", false, /\.png$/);
        case "en":
          return require.context("@/assets/tutorials/en", false, /\.png$/);
        case "de":
        default:
          return require.context("@/assets/tutorials/de", false, /\.png$/);
      }
    }
  }
};
